import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { loadMockups } from '../../../../store/ducks/fabrication-mockups/actions';
import { loadProjects } from '../../../../store/ducks/fabrication-projects/actions';
import { IFabricationProject } from '../../../../store/ducks/fabrication-projects/types';
import ProjectsFilter from './ProjectsFilter';
import ProjectsTable from './ProjectsTable/';
import { Container } from './styles';
import UploadProjects from './UploadProjects';
import { useOnFilter } from './ProjectsFilter/useOnFilterProjects';

const Projects: React.FC = () => {
  const dispatch = useDispatch();

  const projectState = useSelector(
    (state: ApplicationState) => state.fabricationProjects
  );
  const contractNumber = projectState.contractNumber;

  const updateProjectsTable = () => {
    if (!contractNumber) {
      return;
    }

    dispatch(loadProjects(contractNumber));
    dispatch(loadMockups(contractNumber));
  };

  const [filteredProjects, setFilteredProjects] = useState<
    IFabricationProject[]
  >(projectState.projects ?? []);

  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    if (projectState.projects) {
      setFilteredProjects(projectState.projects);
      setSearchInput('');
    }
  }, [projectState.projects]);

  const { handleFilterBySearchInput } = useOnFilter();

  const handleExistingProject = (filename: string) => {
    setSearchInput(filename);
    const projects = projectState.projects ?? [];
    const filteredProjects = handleFilterBySearchInput(
      filename.toUpperCase(),
      projects
    );
    setFilteredProjects(filteredProjects);
  };

  return (
    <Container isFacelift>
      {!projectState.loading && !!contractNumber && (
        <>
          <UploadProjects
            updateProjectsTable={updateProjectsTable}
            handleExistingProject={handleExistingProject}
          />
          <ProjectsFilter
            projectState={projectState}
            filteredProjects={filteredProjects}
            setFilteredProjects={setFilteredProjects}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            onCleanFilters={() =>
              setFilteredProjects(projectState.projects || [])
            }
          />
          <ProjectsTable
            contractNumber={contractNumber}
            filteredProjects={filteredProjects}
            searchTerm={searchInput}
            updateProjectsTable={updateProjectsTable}
          />
        </>
      )}
      {projectState.loading && (
        <Skeleton count={6} style={{ margin: '0.5rem 0' }} />
      )}
    </Container>
  );
};

export default Projects;
